import { BlastAtmosphere } from '../components/BlastAtmosphere'
import { Button } from '../components/Button'
import { EmptyState, ErrorState, LoadingState } from '../components/Feedback'
import { PlayerAvatar } from '../components/PlayerAvatar'
import { api, ApiError } from '../lib/api'
import { dateTime } from '../lib/format'
import { Link } from '../lib/router'
import { useApi } from '../lib/useApi'
import { TournamentJoinCommand } from '../components/TournamentJoinCommand'
import { tournamentStateLabel } from '../lib/tournamentLabels'

export function TournamentsPage() {
  const active = useApi('active-tournament', api.activeTournament)
  const hall = useApi('hall-of-fame', api.hallOfFame)
  const noActive = active.error instanceof ApiError && active.error.code === 'ACTIVE_TOURNAMENT_NOT_FOUND'
  const tournament = active.data?.data
  const tournamentName = tournament?.displayName?.trim() || 'Torneo ufficiale BlastCore'

  return (
    <main className="section page page--charged page--tournaments">
      <BlastAtmosphere variant="subtle" />
      <header className="page-heading tournament-heading">
        <p className="eyebrow">Eliminazione singola · 1v1</p>
        <h1>Entra nel bracket.</h1>
        <p>
          Tornei ufficiali seeded per MMR. Le iscrizioni e ogni azione di gioco
          avvengono direttamente sul server.
        </p>
      </header>

      {active.loading ? <LoadingState label="Verifica torneo attivo" /> : null}
      {active.error && !noActive ? <ErrorState /> : null}
      {noActive ? (
        <EmptyState
          message="Il prossimo torneo verrà aperto dallo staff."
          title="Nessun torneo attivo"
        />
      ) : null}

      {tournament ? (
	  <section className="featured-tournament">
	    <div className="featured-tournament__main">
	      <div className="featured-tournament__topbar">
		<span
		  className={`status-chip status-chip--${tournament.status}`}
		>
		  {tournamentStateLabel(tournament.status)}
		</span>

		<span className="featured-tournament__id">
		  {tournament.id}
		</span>
	      </div>

	      <div className="featured-tournament__identity">
		<p className="eyebrow">Torneo ufficiale BlastCore</p>

		<h2>{tournamentName}</h2>

		<p>
		  {tournament.participantCount}/{tournament.size} giocatori
		  <span aria-hidden="true"> · </span>
		  Eliminazione diretta
		  <span aria-hidden="true"> · </span>
		  Seeding MMR
		</p>
	      </div>

	      <div className="featured-tournament__footer">
		<div className="featured-tournament__actions">
		  <Button to={`/tournaments/${tournament.id}`}>
		    Dettagli tabellone
		  </Button>

		  <Button to="/leaderboard" variant="secondary">
		    Vedi classifica
		  </Button>
		</div>

		{tournament.status === 'registration' ? (
		  <TournamentJoinCommand tournamentId={tournament.id} />
		) : null}
	      </div>
	    </div>

	    <div className="tournament-readout">
	      <div>
		<span>Formato</span>
		<strong>1v1</strong>
	      </div>

	      <div>
		<span>Dimensione</span>
		<strong>{tournament.size}</strong>
	      </div>

	      <div>
		<span>Aggiornato</span>
		<strong>{dateTime(tournament.updatedAt)}</strong>
	      </div>
	    </div>
	  </section>
	) : null}

      <section className="hall-section">
        <header className="section-heading">
          <p className="eyebrow">Risultati storici</p>
          <h2>Albo d'oro</h2>
        </header>
        {hall.loading ? <LoadingState label="Caricamento campioni" /> : null}
        {hall.error ? (
          <ErrorState
            message="I risultati storici non sono disponibili."
            title="Hall of Fame offline"
          />
        ) : null}
        {!hall.loading && !hall.error && hall.data?.data.length === 0 ? (
          <EmptyState
            message="Nessun torneo completato è ancora registrato."
            title="Il primo campione deve ancora emergere"
          />
        ) : null}
        <div className="hall-grid">
          {hall.data?.data.map((entry) => (
            <Link
              className="hall-card panel"
              key={entry.tournamentId}
              to={`/tournaments/${entry.tournamentId}`}
            >
              {entry.winner ? (
                <PlayerAvatar
                  size={72}
                  username={entry.winner.username}
                  uuid={entry.winner.uuid}
                />
              ) : (
                <span className="hall-card__void">—</span>
              )}
              <div>
                <span className="eyebrow">
		  {entry.tournamentDisplayName} · {entry.seasonId}
		</span>
                <h3>{entry.winner?.username ?? 'Nessun vincitore'}</h3>
                <p>
                  Torneo da {entry.size} · {dateTime(entry.completedAt)}
                </p>
              </div>
              <strong>{entry.winnerTournamentWins} vittorie torneo</strong>
            </Link>
          ))}
        </div>
      </section>
    </main>
  )
}
